/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import Icon from '@ant-design/icons';

const UndoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    stroke="#414141"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="3"
    color="#414141"
    viewBox="0 0 24 24"
  >
    <path d="M8 4L4 8l4 4"></path>
    <path d="M4 8h10.5a5.5 5.5 0 015.5 5.5v0a5.5 5.5 0 01-5.5 5.5H5"></path>
  </svg>
);

export const UndoIcon = props => <Icon component={UndoSvg} {...props} />;
